export default class BankStatementSummary {
    income = 0;
    outcome = 0;
}